import {
  tabs,
  site_cards,
  sites_filters,
  site_types,
  site_statuses,
  site_rows,
  certificate_cards,
  certificate_rows,
  incident_cards,
  incident_rows,
  create_initial_site_form
} from './facilities_sites_shared';
import { site_drawers } from './facilities_sites_drawers';

export default {
  name: 'ComplyonFacilitiesSites',
  data: () => ({
    tabs,
    active_tab: 'sites',
    site_cards,
    sites_filters,
    active_sites_filter: 'all',
    site_types,
    site_statuses,
    site_rows,
    certificate_cards,
    certificate_rows,
    incident_cards,
    incident_rows,
    site_drawers,
    site_modal_open: false,
    active_site_drawer_key: null,
    site_form: create_initial_site_form()
  }),
  computed: {
    active_site_drawer() {
      if (!this.active_site_drawer_key) return null;
      return this.site_drawers[this.active_site_drawer_key] || null;
    },
    visible_sites_filters() {
      return this.sites_filters.map((filter) => ({
        ...filter,
        active: this.active_sites_filter === filter.id
      }));
    },
    filtered_site_rows() {
      if (this.active_sites_filter === 'all') return this.site_rows;

      const filter_map = {
        offices: ['Office'],
        clinics: ['Clinic'],
        other: ['Warehouse', 'Training site']
      };

      return this.site_rows.filter((row) => filter_map[this.active_sites_filter]?.includes(row.type));
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    },
    set_sites_filter(filter_id) {
      this.active_sites_filter = filter_id;
    },
    site_ref_for_name(site_name) {
      const row = this.site_rows.find((item) => item.site === site_name);
      return row ? row.ref : null;
    },
    open_site_modal() {
      this.site_modal_open = true;
    },
    close_site_modal() {
      this.site_modal_open = false;
      this.site_form = create_initial_site_form();
    },
    create_site() {
      this.close_site_modal();
    },
    open_site_drawer(site_or_ref) {
      const ref = typeof site_or_ref === 'string' ? site_or_ref : site_or_ref?.ref;
      if (!ref || !Reflect.has(this.site_drawers, ref)) return;
      this.active_site_drawer_key = ref;
    },
    close_site_drawer() {
      this.active_site_drawer_key = null;
    }
  }
};
